import React, { FC, useEffect, useState } from "react";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { MyInput } from "pages/StepPages/StepTwo/MyInput/MyInput";
import { MySelect } from "pages/StepPages/StepTwo/MySelect/MySelect";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { UploadField } from "components-new/UploadField/UploadField";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { useParams } from "react-router-dom";
import { uploadDocument } from "toolkit/documents/folders/folders.thunks";
import styles from "./UploadingDocument.module.sass";

interface UploadingDocumentProps {
	close: () => void;
}

interface ISelect {
	id: number;
	name: string;
}

interface IRequiredFields {
	name: string;
	folder: ISelect | null;
}

export const UploadingDocument: FC<UploadingDocumentProps> = ({ close }) => {
	const [documentAttached, setDocumentAttached] = useState<boolean>(false);
	const [submitError, setSubmitError] = useState<boolean>(false);
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const { folders } = useAppSelector((state) => state.folders);
	const [folderList, setFolderList] = useState<{ id: number; name: string }[]>([]);
	const { folderId } = useParams();
	const dispatch = useAppDispatch();

	const [requiredFields, setRequiredFields] = useState<IRequiredFields>({
		name: "",
		folder: null,
	});

	useEffect(() => {
		const list: { id: number; name: string }[] = [];
		for (let key in folders) {
			// eslint-disable-next-line array-callback-return
			folders[key as keyof typeof folders].map((folder) => {
				list.push(folder);
			});
		}
		setFolderList(list);
	}, [folders]);

	useEffect(() => {
		if (!folderList.length) return;
		const folderIndex = folderList.findIndex((folder) => folder.id === Number(folderId));
		setRequiredFields({
			...requiredFields,
			folder: {
				id: Number(folderId),
				name: folderList[folderIndex].name,
			},
		});
		//eslint-disable-next-line
	}, [folderList]);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (Object.values(requiredFields).filter((item) => item).length !== Object.keys(requiredFields).length) {
			setSubmitError(true);
		} else {
			setModalWindow(true);
			setSubmitError(false);
		}
	};

	const uploadDocumentHandler = (document: any) => {
		dispatch(
			uploadDocument({
				name: requiredFields.name,
				folderId: requiredFields.folder!.id,
				file: document,
				callBack: () => close(),
				handler: Boolean(Number(folderId) === requiredFields.folder?.id),
			}),
		);
	};

	return (
		<section className={styles.wrp}>
			{modalWindow && (
				<ModalWindow close={close} width={documentAttached ? "" : "huge"}>
					<UploadField
						close={close}
						setDocumentAttached={setDocumentAttached}
						onSubmit={(document: any) => uploadDocumentHandler(document)}
					/>
				</ModalWindow>
			)}
			<h4 className={styles.title}>Загрузка документа</h4>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<MyInput
						className={styles.item}
						name="Название документа"
						placeholder="Устав от 20.03.2022"
						value={requiredFields.name}
						set={(e) => setRequiredFields({ ...requiredFields, name: e.target.value })}
						required={true}
						condition={submitError && !requiredFields.name.trim()}
					/>
					<MySelect
						className={styles.item}
						list={folderList}
						value={requiredFields.folder?.name || ""}
						set={(selected: any) => setRequiredFields({ ...requiredFields, folder: selected })}
						name="Папка"
						placeholder="Выберите папку"
						width="full"
						required={true}
						error={submitError}
					/>
				</div>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отменить
					</Button>
					<Button type="submit" className={styles.button}>
						Продолжить
					</Button>
				</div>
			</form>
		</section>
	);
};
